export const validateNoPOBox = (value, allowEmpty) => {
  return (
    (!value && allowEmpty) ||
    !/\bP(ost|ostal)?([ .]*O(ffice)?)?([ .]*Box)?\b/i.test(value)
  )
}

export const pickValueFromPlace = (place, addressComponentKey) => {
  const handler = {
    get(target, name) {
      // eslint-disable-next-line no-prototype-builtins
      return target.hasOwnProperty(name) ? target[name] : ''
    },
  }

  const emptyProxy = new Proxy({}, handler)
  return (
    place.address_components.find(
      (element) =>
        element.types.filter((c) => c !== 'political')[0] ===
        addressComponentKey,
    ) || emptyProxy
  )
}
